import { Button } from '@/root/ui/tuuleliinid'
import Icon from '@/root/ui/shared/Icon'
import { ButtonHTMLAttributes, FC } from 'react'

interface ButtonWithIconProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  iconType: string
  label: string
  iconColor?: string
  iconWidth?: number
}

export const ButtonWithIcon: FC<ButtonWithIconProps> = ({
  iconType,
  label,
  iconWidth,
  iconColor,
  className,
  ...props
}) => {
  return (
    <Button className={className} {...props}>
      <div className="flex items-center">
        <Icon alt={iconType} type={iconType} width={iconWidth || 20} color={iconColor} />
        <div className="ms-2 pt-1">{label}</div>
      </div>
    </Button>
  )
}

export default ButtonWithIcon
